import { render, staticRenderFns } from "./Product.vue?vue&type=template&id=26990b64&scoped=true&"
import script from "./Product.vue?vue&type=script&lang=js&"
export * from "./Product.vue?vue&type=script&lang=js&"
import style0 from "../../less/gift.less?vue&type=style&index=0&id=26990b64&lang=less&scoped=true&"
import style1 from "./Product.vue?vue&type=style&index=1&id=26990b64&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26990b64",
  null
  
)

export default component.exports